function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
import RPT from 'prop-types';
import getDisplayName from '../libs/getDisplayName';
import PrefetchException from './PrefetchException';
var Component = React.PureComponent || React.Component;
/**
 * Makes decorator for wrapping component into Prefetch component
 *
 * @param  {Array} prefetchActions — returns actions creators by specified paths
 * @return {Function} — decorator for wrapping component into Prefetch
 */

export default function prefetchWrapper(prefetchActions) {
  return function (Wrapped) {
    var _class, _temp;

    return _temp = _class = /*#__PURE__*/function (_Component) {
      _inherits(PrefetchWrapper, _Component);

      function PrefetchWrapper(props, context) {
        var _this;

        _classCallCheck(this, PrefetchWrapper);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(PrefetchWrapper).call(this, props, context));
        var prefetchCursor = _this.context.prefetchCursor; // Is server side prefetch render

        if (prefetchCursor) {
          // Count prefetch Wrappers
          prefetchCursor.current += 1; // Was this wrapper previously prefetched

          if (prefetchCursor.current > prefetchCursor.last) {
            // Remember that we have prefetched this wrapper
            prefetchCursor.last += 1; // Tell prefetcher to wait for all dispatched actions
            // then run again with prefetched data

            throw new PrefetchException(_this.dispatchPrefetchActions());
          }
        }

        return _this;
      }
      /**
       * Dispatch prefetch actions
       *
       * @return {Array.<Object>} — list of dispatched actions
       */


      _createClass(PrefetchWrapper, [{
        key: "dispatchPrefetchActions",
        value: function dispatchPrefetchActions() {
          var _this2 = this;

          var dispatch = this.context.store.dispatch;
          return prefetchActions.map(function (action) {
            return action(_this2.props);
          }).map(function (action) {
            return dispatch(action);
          });
        }
      }, {
        key: "componentDidMount",
        value: function componentDidMount() {
          this.dispatchPrefetchActions();
        }
      }, {
        key: "render",
        value: function render() {
          return React.createElement(Wrapped, this.props);
        }
      }]);

      return PrefetchWrapper;
    }(Component), _defineProperty(_class, "displayName", "Prefetch(".concat(getDisplayName(Wrapped), ")")), _defineProperty(_class, "contextTypes", {
      store: RPT.object.isRequired,
      prefetchCursor: RPT.object
    }), _defineProperty(_class, "propTypes", {
      location: RPT.object,
      params: RPT.object
    }), _temp;
  };
}